import { useCallback, useEffect, useState } from 'react';

import {
  getVendorTaxonomyKeyFromVendorType,
  VendorTypeEnum,
} from '@zola-helpers/client/dist/es/marketplace/vendorUtils';

import { useModal } from '~/contexts/ModalContext';
import { useUserContext } from '~/contexts/UserContext';
import ApiService from '~/util/apiService';
import { isAutomatedTest } from '~/util/automatedTestUtils';
import { StandardLogFn } from '~/util/logger';

import { InquiryResolutionsModalProps } from '../types';
import { snoozeModal } from '../utils/utils';

const useInquiriesResolutionsModal = () => {
  const { showV2PredefinedModal, hideModal } = useModal();
  const [refreshOnClose, setRefreshOnClose] = useState(false);

  const user = useUserContext();

  const onClose = useCallback(() => {
    if (refreshOnClose) {
      window.location.reload();
    } else {
      hideModal();
    }
    snoozeModal();
  }, [hideModal, refreshOnClose]);

  useEffect(() => {
    // wait 2 seconds before launching this modal to ensure no other modals on the page
    setTimeout(() => {
      const existingModal = document.getElementById('modal');
      if (user && !user.is_guest && !isAutomatedTest() && !existingModal) {
        ApiService.get('/web-marketplace-api/v1/user-prompt/prompt?prompt_key=INQUIRY_MAINTENANCE')
          .then(({ eligibleForPrompt, metadata }) => {
            if (eligibleForPrompt && metadata?.vendorType) {
              ApiService.post(`/web-marketplace-api/v1/inquiry/account/list`, {
                statuses: ['CONNECTED'],
                vendorType: metadata.vendorType,
              })
                .then(({ entities }) => {
                  if (entities.length) {
                    showV2PredefinedModal<InquiryResolutionsModalProps>(
                      'INQUIRY_RESOLUTIONS_MODAL',
                      {
                        showCloseButton: false,
                        closeOnOverlayClick: false,
                        closeOnEscape: false,
                        dialogHeadingId: 'dialog-heading',
                        triggerRef: null,
                        lockBgScrolling: true,
                        onClose,
                      },
                      {
                        vendorType: getVendorTaxonomyKeyFromVendorType(
                          metadata.vendorType as VendorTypeEnum
                        ),
                        initialInquiries: entities,
                        setRefreshOnClose,
                      }
                    );
                  }
                })
                .catch(StandardLogFn);
            }
          })
          .catch(StandardLogFn);
      }
    }, 2000);
  }, [onClose, showV2PredefinedModal, user]);
};

export default useInquiriesResolutionsModal;
